import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import ErrorBoundary from '../../hoc/ErrorBoundary/ErrorBoundary';
import CustomTabs from "components/CustomTabs/CustomTabs.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";

// Module Tabs
import SettingsTab from './modules/Settings/SettingsTab';
import TemplatesTab from './modules/Templates/TemplatesTab';
import ViewTags from "../Forms/ViewTags";
import Disposition from "../Forms/Disposition";
import Tags from './Tags';
import WhatsappKeywords from './WhatsappKeywords';
import InformationLink from '../InformationLink/InformationLink';
import SupportCategory from '../Support/Settings';
import SupportDevConfigPage from '../SupportDev/SupportDevConfigPage';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%'
  },
  title: {
    marginBottom: theme.spacing(3)
  }
}));

const SettingsAdminPage = (props) => {
  const { user, history, match } = props;
  const classes = useStyles();
  const [ activeTab, setActiveTab ] = useState(0);
  const [campaignDetails, setCampaignDetails] = useState(null);
  const [isMobile] = useState(window.innerWidth <= 760);
  const [searchParams, setSearchParams] = useState(new URLSearchParams(window.location.search));

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tab = urlParams.get('tab');
    setSearchParams(urlParams);
    if (tab) {
      setActiveTab(parseInt(tab));
    }
  }, [window.location.search]); // Important: Depend on window.location.search

  const handleTabChange = (event, value) => {
    setActiveTab(value);
    history.push({
      search: `?tab=${value}`,
    });
  };

  const tabs = [
    {
      tabName: "Info Link",
      tabContent: (
        <ErrorBoundary name="Disposition">
          <InformationLink user={user} history={history} />
        </ErrorBoundary>
      )
    },
    {
      tabName: "Support Category",
      tabContent: (
        <ErrorBoundary name="Settings">
          <SupportCategory user={user} history={history} match={match}/>
        </ErrorBoundary>
      )
    },
    {
      tabName: "Support Dev Settings",
      tabContent: (
        <ErrorBoundary name="Templates">
          <SupportDevConfigPage user={user} history={history} />
        </ErrorBoundary>
      )
    }
  ];

  return (
      <div className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            {campaignDetails && (
              <Typography variant="h5" component="h2" className={classes.title}>
                {campaignDetails.name}
              </Typography>
            )}
            <CustomTabs
              key={searchParams.toString()} // Add the key prop here
              title=""
              headerColor="info"
              tabs={tabs}
              value={activeTab}
              onChange={handleTabChange}
            />
          </GridItem>
        </GridContainer>
      </div>
  );
};

SettingsAdminPage.propTypes = {
  user: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired
};

export default SettingsAdminPage;